import { format, formatDistanceToNow, isPast, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export function formatDueDate(dueDate: string, status: string): string {
  const date = parseISO(dueDate);
  
  if (status === 'paid') {
    return format(date, 'dd/MM/yyyy', { locale: ptBR });
  }

  if (isPast(date)) {
    return `Há ${formatDistanceToNow(date, { locale: ptBR })}`;
  }

  return format(date, 'dd/MM/yyyy', { locale: ptBR });
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'paid':
      return 'hsl(var(--chart-2))'; // green
    case 'overdue':
      return 'hsl(var(--destructive))'; // red
    case 'pending':
      return 'hsl(var(--chart-4))'; // orange
    default:
      return 'hsl(var(--muted-foreground))';
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case 'paid':
      return 'Pago';
    case 'overdue':
      return 'Vencido';
    case 'pending':
      return 'A vencer';
    default:
      return status;
  }
}

export function validateFile(file: File): { valid: boolean; error?: string } {
  const maxSize = 20 * 1024 * 1024; // 20MB
  const allowedTypes = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'application/pdf',
    'video/mp4',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
  ];

  if (file.size > maxSize) {
    return { valid: false, error: 'Arquivo muito grande. Máximo 20MB.' };
  }

  if (!allowedTypes.includes(file.type)) {
    return { valid: false, error: 'Tipo de arquivo não permitido.' };
  }

  return { valid: true };
}
